import { render } from "./ISPBroadbandPage.vue?vue&type=template&id=97309434&ts=true"
import script from "./ISPBroadbandPage.vue?vue&type=script&lang=ts"
export * from "./ISPBroadbandPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__